import React, {useState} from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
    Card,
    CardContent,
} from "@mui/material";
import ampoules from "../../images/ampoules.jpg"
import SearchIcon from '@mui/icons-material/Search';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import VerifiedIcon from '@mui/icons-material/Verified';
import SecurityIcon from '@mui/icons-material/Security';
import ContactUs from "../ContactUs";
import Partenaires from "../Partenaires";
import AnimatedBackgroundBox from "../AnimationBackgroundBox";
import Grid2 from "@mui/material/Unstable_Grid2";
const ElecGenerale = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        compagny: '',
        phoneNumber:'',
        message: '',
    });

    // Permet de mettre a jour les data saisies par l'user
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const bull = (
        <Box
            component="span"
            sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
        >
            •
        </Box>
    );
    return (
        <React.Fragment>
            <AnimatedBackgroundBox backgroundImage={ampoules} position={'center'} size={'cover'}>
                <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#ebefef', fontFamily: 'unset',
                    textShadow: `
                            0px 0px 8px rgba(0, 0, 0, 0.3),   
                            0px 0px 16px rgba(0, 0, 0, 0.3),  
                            0px 0px 24px rgba(0, 0, 0, 0.3)   
                        `,
                    fontSize: {
                        xs: '2.5rem', // Taille plus petite sur les téléphones
                        sm: '2.5rem', // Taille moyenne sur les tablettes
                        md: '5rem', // Taille normale sur les grands écrans
                    },
                }}>
                    Électricité générale
                </Typography>

                {/*<Typography variant="h4" sx={{ color: '#F5F5F5', marginTop: '10px', paddingTop: '25px', fontFamily: 'unset', fontWeight: 'bold',*/}
                {/*    textShadow: `*/}
                {/*            0px 0px 8px rgba(0, 0, 0, 1),   */}
                {/*            0px 0px 16px rgba(0, 0, 0, 1),  */}
                {/*            0px 0px 24px rgba(0, 0, 0, 1)   */}
                {/*        `*/}
                {/*}}>*/}
                {/*    Nous prenons en charge tous vos travaux d’électricité générale : installation, rénovation et dépannage.*/}
                {/*    Profitez de notre sécurité, qualité et expertise à chaque étape.*/}
                {/*</Typography>*/}
            </AnimatedBackgroundBox>


            <Box sx={{
                padding: { xs: '20px ', md: '70px 0' },
                //backgroundColor: 'rgba(233,240,246,0.98)'
                backgroundColor: '#f0f4fa'
            }}>
                <Box sx={{ maxWidth: 'lg', margin: '0 auto', textAlign: 'center' }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontFamily: 'unset',
                            color: '#2c2d2e',
                            paddingBottom: '50px',
                            textAlign: 'centre', // Centrage du texte
                            // fontStyle: 'italic'
                            fontSize: { xs: '1.5rem', md: '2rem' }, // Taille réduite sur mobile


                        }}
                    >
                        Chez CP, nous proposons des services d'électricité générale <br/>
                        pour les professionnels et les particuliers. <br />
                        {/*Que ce soit pour l'installation, la rénovation ou la maintenance de vos systèmes électriques, nous garantissons sécurité, performance et conformité, tout en optimisant votre consommation énergétique.*/}
                    </Typography>

                    <Grid2 container spacing={4} justifyContent="center"> {/* Centrage des cartes */}
                        {/** Tableau de données pour les cartes */}
                        {[
                            {
                                icon: <SearchIcon sx={{ fontSize: 75, color: '#05acf3', mb: 2 }} />,
                                title: "ÉTUDE ET DIAGNOSTIC ÉLECTRIQUE",
                                description: "Nous réalisons des études et diagnostics complets de vos installations pour garantir leur conformité et améliorer leur performance."
                            },
                            {
                                icon: <ElectricalServicesIcon sx={{ fontSize: 75, color: '#05acf3', mb: 2 }} />,
                                title: "RÉNOVATION ÉLECTRIQUE",
                                description: "Modernisez vos installations électriques vieillissantes pour améliorer la sécurité et optimiser votre consommation énergétique."
                            },
                            {
                                icon: <VerifiedIcon sx={{ fontSize: 75, color: '#05acf3', mb: 2 }} />,
                                title: "MISE EN CONFORMITÉ",
                                description: "Nous vous accompagnons dans la mise en conformité de vos installations électriques selon les normes en vigueur pour garantir sécurité et performance."
                            },
                            {
                                icon: <SecurityIcon sx={{ fontSize: 75, color: '#05acf3', mb: 2 }} />,
                                title: "NORME ET SÉCURITÉ",
                                description: "Protégez vos installations contre les surtensions, les incendies électriques et les pannes grâce à nos solutions de sécurité électrique."
                            }
                        ].map((card, index) => (
                            <Grid2 xs={12} sm={6} md={6} key={index}>
                                <Card
                                    sx={{
                                        minWidth: 300,
                                        minHeight: 300,
                                        maxHeight: 350,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 8,
                                        //boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.2)' // Ombre plus accentuée
                                        boxShadow: '0px 5px 5px rgb(170, 187, 250, 0.5), 0px 5px 10px rgb(170, 187, 250, 0.4) '
                                    }}
                                >
                                    <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                        {card.icon}
                                        <Typography variant="h4" sx={{ mb: 1.5, fontFamily: 'unset' }}>
                                            {card.title}
                                        </Typography>
                                        <Typography variant="subtitle1" sx={{ fontFamily: 'unset' }}>
                                            {card.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid2>
                        ))}
                    </Grid2>

                </Box>
            </Box>


            <Box>
                <Partenaires></Partenaires>
            </Box>

            <Box>
                <ContactUs></ContactUs>
            </Box>



        </React.Fragment>

    );
};

export default ElecGenerale;